import TableCell from "@mui/material/TableCell/TableCell";
import { IAdditional } from "../TableTemplate/tableTemplate";
import { ISahraTableReports } from "../../Interfaces/SahraTableInterfaces";
import { toast } from "react-toastify";
import {
  disableSahraUser,
  disableSahraUserTrade,
  enableSahraUser,
  enableSahraUserTrade,
} from "../../Requests/Sahra/sahraUsersRequests";
import Button from "../../Components/Button";
import { useNavigate } from "react-router-dom";
import React from "react";
import ToggleSwitch from "../../Components/ToggleSwitch";
import { packetErrorHandler } from "../../Utils/requestUtils";
// Common Components
import { Modal } from "src/Components";
// Local Components
import AddOrEditSahraUser from "src/Forms/AddOrEditSahraUser";

const SahraUsersTableAdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">عملیات</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">قابلیت معامله</span>
      </TableCell>
    </>
  );
};

const SahraUsersAdditionalCol: React.FC<{
  row: ISahraTableReports;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const navigate = useNavigate();
  const [isEditOpen, setIsEditOpen] = React.useState(false);

  const getDisableEnableProperFunction = () => {
    if (row.isActive) return disableSahraUser(row.id);
    return enableSahraUser(row.id);
  };

  const enableDisableHandler = () => {
    getDisableEnableProperFunction()
      .then((res) => {
        if (res.data) {
          toast.success(res.msg);
          onAction();
        } else toast.error(res.msg);
      })
      .catch((e) => {
        toast.error(e.msg);
      });
  };

  const getCanTradeProperFunction = () => {
    if (row.canTrade) return disableSahraUserTrade(row.id);
    return enableSahraUserTrade(row.id);
  };

  const getEnableDisableBtnText = () => {
    if (row.isActive) return "غیر فعال کردن";
    return "فعال کردن";
  };

  const canTradeChangeHandler = () => {
    getCanTradeProperFunction()
      .then((res) => {
        if (res.data) {
          toast.success(res.msg);
          onAction();
        } else toast.error(res.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <>
      <TableCell>
        {isEditOpen ? (
          <Modal
            title="ویرایش کاربر"
            UI={
              <AddOrEditSahraUser
                onClose={() => {
                  setIsEditOpen(false);
                  onAction();
                }}
                userId={row.id}
              />
            }
            onClose={() => setIsEditOpen(false)}
            modalBoxClassName="!min-w-[300px]"
          />
        ) : (
          <></>
        )}
        <div className="flex flex-row gap-2 w-min">
          <Button
            className="table-btn"
            onClick={enableDisableHandler}
            text={getEnableDisableBtnText()}
            variant="contained"
          />
          <Button
            className="table-btn"
            onClick={() => setIsEditOpen(true)}
            text="ویرایش"
            variant="contained"
          />
        </div>
      </TableCell>
      <TableCell>
        <ToggleSwitch
          checked={row.canTrade}
          label=""
          name=""
          onChange={canTradeChangeHandler}
        />
      </TableCell>
    </>
  );
};

export const SahraUsersTableAdditional: IAdditional<ISahraTableReports> = {
  getHeader: SahraUsersTableAdditionalHeader,
  getRow: SahraUsersAdditionalCol,
};
